// Utilities
import EditBox from 'Mixins/EditBox'
import { checkApiResponse } from 'Utils'

export default {
  mixins: [EditBox],

  components: {
    ChecklistsToolsBox: () => import('../components/ChecklistsToolsBox'),
  },

  props: {
    changesSaved: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      apiCallSucceed: false,
    }
  },

  methods: {
    checkApiResponse,
    async changeSavedToggle() {
      this.apiCallSucceed = true
      await this.$nextTick()
      this.apiCallSucceed = false
    },
    /**
     * Get Checklist Data
     *
     * @param {Object} extraParams For overide current object key or adding information.
     * @returns {Object} Provided values. Card id & action type by default.
     */
    getChecklistData(extraParams) {
      return {
        cardId: this.$route.params.card_id || this.$route.params.temp_id,
        actionType: this.isTemplatePage ? 'templates' : 'card',
        ...extraParams,
      }
    },
    /**
     * Save changes
     *
     * Emits a update event sending the new values to a parent component which will
     * deal with the API call to update.
     *
     * @param {Object} updatedValues
     */
    saveChanges(updatedValues) {
      this.$emit('save-changes', updatedValues)
    },
  },
}
